import React, { useCallback, useEffect, useState } from "react";
import { Alert, Box, Chip, LinearProgress } from "@mui/material";
import { AppButton } from "components/common/buttons";
import { AppTab, AppTabPanel } from "components/common/tabs";
import { getContractItemSections } from "../../services/contractItemStructure.service";
import ContractItemsTable from "./ContractItemsTable";

export default function ContractItemsTabs({ contractId, contract, onSnackbar }) {
  const [structure, setStructure] = useState({ contractId: null, sections: [], loading: true, error: "" });
  const [sectionId, setSectionId] = useState(null);
  const [scopeId, setScopeId] = useState(null);
  const [revision, setRevision] = useState(0);
  const reloadStructure = useCallback(() => setRevision((current) => current + 1), []);

  useEffect(() => {
    let active = true;
    setStructure({ contractId, sections: [], loading: true, error: "" });
    getContractItemSections(contractId).then((sections) => {
      if (active) setStructure({ contractId, sections, loading: false, error: "" });
    }).catch(() => {
      if (active) setStructure({ contractId, sections: [], loading: false, error: "Không thể tải phạm vi hạng mục hợp đồng. Vui lòng thử lại." });
    });
    return () => { active = false; };
  }, [contractId, revision]);

  if (structure.contractId !== contractId || structure.loading) return <LinearProgress aria-label="Đang tải phạm vi hạng mục" />;
  if (structure.error) return <Alert severity="error" action={<AppButton variant="outlined" onClick={reloadStructure}>Thử lại</AppButton>}>{structure.error}</Alert>;
  // Legacy contracts without sections keep their existing item table.
  if (!structure.sections.length) return <ContractItemsTable key={contractId} contractId={contractId} contract={contract} onSnackbar={onSnackbar} onStructureChanged={reloadStructure} />;

  const section = structure.sections.find((entry) => entry.contractSectionId === sectionId) || structure.sections[0];
  const scopes = section.scopes || [];
  const scope = scopes.find((entry) => entry.contractItemScopeId === scopeId) || scopes[0];
  const isCommuneTotal = section.sectionType === "COMMUNE_DETAIL" && scope?.scopeType === "TOTAL";
  const readOnly = !section.isActive || scope?.isEditable === false || isCommuneTotal;

  return <Box>
    <AppTab aria-label="Loại hạng mục" value={section.contractSectionId}
      tabs={structure.sections.map((entry) => ({ value: entry.contractSectionId, label: entry.sectionName }))}
      onChange={(_, value) => { setSectionId(value); setScopeId(null); }} />
    {scope ? <>
      <AppTab aria-label="Phạm vi hạng mục" value={scope.contractItemScopeId}
        tabs={scopes.map((entry) => ({ value: entry.contractItemScopeId, label: entry.scopeName }))}
        onChange={(_, value) => setScopeId(value)} />
      <AppTabPanel value={scope.contractItemScopeId} index={scope.contractItemScopeId} aria-label={scope.scopeName} sx={{ pt: 2 }}>
        {isCommuneTotal && <Chip label="Dữ liệu tổng hợp tự động" size="small" sx={{ mb: 1, mr: 1 }} />}
        {readOnly && !isCommuneTotal && <Chip label="Chỉ xem" size="small" sx={{ mb: 1 }} />}
        <ContractItemsTable key={`${contractId}:${scope.contractItemScopeId}`} contractId={contractId} contract={contract}
          scopeId={scope.contractItemScopeId} readOnly={readOnly}
          summaryScopeIds={isCommuneTotal ? scopes.filter((entry) => entry.scopeType === "COMMUNE").map((entry) => entry.contractItemScopeId) : null}
          onSnackbar={onSnackbar} onStructureChanged={reloadStructure} />
      </AppTabPanel>
    </> : <Alert severity="info" sx={{ mt: 2 }}>Loại hạng mục này chưa có phạm vi.</Alert>}
  </Box>;
}
